import { createContext } from 'react'

const RegulationsContext = createContext()

export default RegulationsContext
